import generateRender from 'shared/utils/generateRender';
import DefaultVideoAdsHeader from '../../../../components/JSModal/components/DefaultHeader';

const ModalHeader = generateRender({
  default: DefaultVideoAdsHeader,
});

export default ModalHeader;

